<template>
	<a-drawer :title="title" :width="1000" placement="right" :closable="true" :visible="visible" @close="close">
    <div>
      <a-tabs v-model="tabsKey" v-if="visible">
        <a-tab-pane key="1" tab="基本信息">
          <a-form :form="form" v-if="showType==2" :rules="validatorRules" style="padding-bottom:50px;">
            <a-row :gutter="24">

              <a-col :md="12" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="日程标题">
                  <a-input placeholder="请输入日程标题" :disabled="disableSubmit || model.type == '10'" v-decorator="['title', validatorRules.title]" />
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划类型">
                  <a-input :value="model.type_dictText || (model.type == '10' ? '周期计划' : '人工创建')" disabled />
                </a-form-item>
              </a-col>



              <a-col :md="12" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="日程时间">
                  <a-range-picker :disabled="disableSubmit" style="width: 100%"
                                  v-decorator="['rangeTime', rangeConfig]" show-time format="YYYY-MM-DD HH:mm:ss" />
                </a-form-item>
              </a-col>

              <a-col :md="12" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设施类型">
                  <j-dict-select-tag :disabled="disableSubmit" @change="operationTypeChange()"
                                     :triggerChange="true"
                                     :defaultState="true" dictCode="operation_type" placeholder="请选择设施类型"
                                     v-decorator="['operationType', validatorRules.operationType]">
                  </j-dict-select-tag>
                </a-form-item>
              </a-col>

              <a-col :md="12" :sm="24" v-if="this.model.operationType == 1">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设施" prop="siteId">
                  <a-select :disabled="disableSubmit" style="width: 100%" placeholder="请选择站点设施"
                            v-model="selectedSite" @dropdownVisibleChange="selectSite">
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col :md="12" :sm="24" v-else>
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设施" prop="siteId">
                  <a-select :disabled="disableSubmit" style="width: 100%" placeholder="请选择管网设施"
                            v-model="selectedSite" @dropdownVisibleChange="selectPipe">
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划项目">
                  <j-dict-select-tag  mode="multiple" :search="true" :triggerChange="true"
                                      :defaultState="true" :disabled="disableSubmit"
                                      dictCode="plan_title" placeholder="请选择计划项目"
                                      v-decorator="['workPlanDetailListStr', validatorRules.workPlanDetailListStr]"
                                      :value="model.workPlanDetailListStr" @change="e=>{changeModelType(e)}">
                  </j-dict-select-tag>
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="执行人">
                  <a-select
                    mode="multiple"
                    :disabled="disableSubmit"
                    style="width: 100%"
                    placeholder="请选择执行人"
                    :value="selectedUser"
                    @dropdownVisibleChange="selectUserIds"
                  >
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col :md="24" :sm="24">
                <a-form-item :labelCol="{ span: 2 }" :wrapperCol="{ span: 15 }" label="备注">
                  <a-textarea :disabled="disableSubmit" :autoSize="{ minRows: 5, maxRows: 5 }"
                              placeholder="请输入内容..." v-decorator="['remark', {}]" />
                </a-form-item>
              </a-col>
              <a-col :md="24" :sm="24" v-if="disableSubmit">
                <a-form-item>
                  <a-table size="middle" :pagination="false"
                           bordered :columns="columns"
                           :dataSource="model.workPlanDetailList">
              <span slot="action" slot-scope="text, record">
                <template v-if="model.type != '10'">
                  <span v-if="record.status == 1">
                    <a-button v-if="canComplete()" type="primary" size="small" @click="handleOpenComplete(record)">去完成</a-button>
                    <span v-else style="color: red">未完成</span>
                  </span>
                  <span v-else>
                    <span style="color: green">已完成</span>
                    <a @click="handleViewProof(record)" style="margin-left: 8px">查看凭证</a>
                  </span>
                </template>
                <template v-else>
                  <a-button v-if="record.status == 1" type="primary" size="small" :loading="cycleTaskLoading" @click="handleCompleteCycleTask(record)">去完成</a-button>
                  <span v-else style="color: green">已完成</span>
                </template>
              </span>
                  </a-table>
                </a-form-item>
              </a-col>
              <a-col :md="24" :sm="24">
                <iws-upload
                  ref="iwupload1"
                  :disableSubmit="disableSubmit"
                  :options="{ btnText: '上传' }"
                  accept=""
                  filesrc="om_work_plan"
                  :srcid="model.id"
                ></iws-upload>
              </a-col>
            </a-row>

          </a-form>
          <!-- </a-spin> -->
          <div v-if="showType!=2" style="margin-bottom: 50px;">
            <div v-for="(item,index) in formList" :key="index">
              <el-form ref="ruleForm" :model="item" label-position="right" label-width="100px" :rules="rules"
                       class="ruleForm">
                <a-divider orientation="left" style="color: white; margin-bottom: 40px"> 工作计划
                </a-divider>
                <a-row :gutter="24">
                  <a-col :md="12" :sm="24">
                    <el-form-item label="日程标题" prop="title">
                      <a-input placeholder="请输入日程标题" v-model="item.title" />
                    </el-form-item>
                  </a-col>

                  <a-col :md="12" :sm="24">
                    <el-form-item label="计划类型">
                      <a-input value="人工创建" disabled />
                    </el-form-item>
                  </a-col>

                  <a-col :md="12" :sm="24">
                    <el-form-item label="日程时间" prop="rangeTime">
                      <a-range-picker style="width: 100%" show-time
                                      v-model="item.rangeTime" format="YYYY-MM-DD HH:mm:ss" />
                    </el-form-item>
                  </a-col>

                  <a-col :md="12" :sm="24">
                    <el-form-item label="设施类型" prop="operationType">
                      <j-dict-select-tag @change="e=>{operationTypeChange(e,index)}" :triggerChange="true"
                                         :defaultState="true"
                                         dictCode="operation_type" placeholder="请选择设施类型"
                                         :value="item.operationType">
                      </j-dict-select-tag>
                    </el-form-item>
                  </a-col>

                  <a-col :md="12" :sm="24" v-if="item.operationType == 1">
                    <el-form-item label="设施" prop="siteId">
                      <a-select style="width: 100%" placeholder="请选择站点设施"
                                :value="item.siteId?selectedSiteList[index]:''"
                                @dropdownVisibleChange="selectSite(item.operationType,index)">
                      </a-select>

                    </el-form-item>
                  </a-col>

                  <a-col :md="12" :sm="24" v-else>
                    <el-form-item label="设施" prop="siteId">
                      <a-select style="width: 100%" placeholder="请选择管网设施"
                                :value="item.siteId?selectedSiteList[index]:''"
                                @dropdownVisibleChange="selectPipe(index)">
                      </a-select>

                    </el-form-item>
                  </a-col>
                  <a-col :md="12" :sm="24">
                    <el-form-item label="计划项目" prop="workPlanDetailListStr">
                      <j-dict-select-tag mode="multiple" :search="true" :triggerChange="true"
                                         :defaultState="true"
                                         dictCode="plan_title" placeholder="请选择计划项目"
                                         :value="item.workPlanDetailListStr" @change="e=>{changeTypes(e,index,'workPlanDetailListStr')}">
                      </j-dict-select-tag>
                    </el-form-item>
                  </a-col>

                  <a-col :md="12" :sm="24">
                    <el-form-item label="执行人" prop="userId">
                      <a-select
                        mode="multiple"
                        style="width: 100%"
                        placeholder="请选择执行人"
                        :value="selectedUserList[index]"
                        @dropdownVisibleChange="selectUserIdsForBatch(index)"
                      >
                      </a-select>
                    </el-form-item>
                  </a-col>

                  <a-col :md="24" :sm="24">
                    <el-form-item label="备注" prop="remark">
                      <a-textarea :autoSize="{ minRows: 5, maxRows: 5 }" placeholder="请输入内容..."
                                  v-model="item.remark" />
                    </el-form-item>
                  </a-col>
                  <a-col :md="24" :sm="24">
                    <iws-upload
                      ref="iwupload"
                      :options="{ btnText: '上传' }"
                      accept=""
                      filesrc="om_work_plan"
                      :srcid="item.id"
                    ></iws-upload>
                  </a-col>
                  <a-col :md="24" :sm="24">
                    <el-form-item>
                      <div style="display: flex;justify-content: flex-end;">
                        <a-button type="danger" icon="delete" @click.stop="deleteItem(index)">
                          删除
                        </a-button>
                        <a-button type="primary" icon="copy" style="margin: 0 15px;"
                                  @click.stop="copyItem(index)">
                          复制
                        </a-button>
                        <a-button type="primary" icon="add" @click.stop="addItem(index)">
                          新增
                        </a-button>
                      </div>
                    </el-form-item>
                  </a-col>
                </a-row>

              </el-form>
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane tab="评论" v-if="model.id" key="3">
          <comment :originId="model.id"  originKey="om_work_plan" :startUser="startUser" v-if="visible"></comment>
        </a-tab-pane>
      </a-tabs>
      <div v-show="tabsKey==1">
        <div :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: 'rgb(21,52,107)',
        textAlign: 'right',
        zIndex: 1,
      }">
          <a-button :style="{ marginRight: '8px' }" @click="handleCancel"> 关 闭</a-button>
          <a-button :loading="confirmLoading" :style="{ marginRight: '8px' }" v-if="!disableSubmit" type="primary" @click="handleOk(false)"> 确 定</a-button>
        </div>
      </div>
    </div>

		<select-user-list-modal ref="UserListModal" @choseUser="choseUser"></select-user-list-modal>
		<select-site-list-modal ref="SiteListModal" @choseArchive="choseSite"></select-site-list-modal>
		<select-pipe-list-modal ref="PipeListModal" @choseArchive="choseSiteByPipe"></select-pipe-list-modal>
		<work-plan-detail-complete-modal ref="completeModal" @ok="handleDetailCompleteOk"></work-plan-detail-complete-modal>
	</a-drawer>
</template>

<script>
import comment from '@comp/comment/comment'
	import {
		httpAction,
		getAction
	} from '@/api/manage'
	import {
		workPlanAddBatch,
		getWorkPlanTypes
	} from '@/api/api'
	import pick from 'lodash.pick'
	import moment from 'moment'
	import JEditor from '@/components/jeecg/JEditor'
	import SelectUserListModal from '../../../system/modules/SelectUserListModal'
	import SelectSiteListModal from '../../../assets/SelectSiteListModal'
	import SelectPipeListModal from '../../../assets/SelectPipeListModal'
  import IwsUpload from '@comp/upload/IwsUpload'
  import { openMaintenanceAction } from '@/views/om/maintenance/maintenanceBusinessActions'
  import WorkPlanDetailCompleteModal from './WorkPlanDetailCompleteModal'



  export default {
		name: 'WorkPlanModal',
		components: {
			JEditor,
			SelectUserListModal,
			SelectSiteListModal,
			SelectPipeListModal,
			WorkPlanDetailCompleteModal,
			// FormModel,
      IwsUpload,
      comment
		},
		data() {
			return {
        startUser:null,
        projectCode:'',
        userInfo:this.$store.getters.userInfo,
        tabsKey:'1',
        planTypeOptions: [],
        createPlanTypeOptions: [],
        cycleTaskLoading: false,
        columns:[{
          dataIndex: 'title_dictText',
          colName: 'title_dictText',
          title: '计划项目',
          width: 120,
          align: 'center',
          customRender: (text, record) => record.title_dictText || record.title || text || '-'
        },{
          title: '完成人',
          dataIndex: 'completedUserName',
          width: 100,
          align: 'center',
          customRender: (text) => text || '-'
        },{
          title: '完成时间',
          dataIndex: 'completedTime',
          width: 150,
          align: 'center',
          customRender: (text) => text || '-'
        },{
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'action' }
        }],
				title: '操作',
				visible: false,
				model: {},
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 14
				},
				dateFormat: 'YYYY-MM-DD HH:mm:ss',
				disabled: true,
				disableSubmit: true,
				rangeConfig: {
					rules: [{
						type: 'array',
						required: true,
						message: '请选择日程时间!'
					}]
				},
        workPlanConfig: {
          rules: [{
            type: 'array',
            required: true,
            message: '请选择计划项目!'
          }]
        },
				/* 添加时默认站点*/
				operationTypeItem: 1,
				confirmLoading: false,
				userId: '',
				executorIds: [],
				// allDay: false,
				selectedUser: [],
				selectedUserList: [
					[]
				],
				userIndex: 0,
				selectedSite: [],
				selectedSiteList: [
					[]
				],
				siteIds: '',
				form: this.$form.createForm(this),
				validatorRules: {
					title: {
						rules: [{
							required: true,
							message: '请输入标题!'
						}]
					},
					// remindType: { rules: [{ required: true, message: '请选择提醒方式!' }] },
					// reminders: { rules: [{ required: true, message: '请选择提醒时间!' }] },
					rangeTime: {
						rules: [{
							required: true,
							message: '请选择日程时间!'
						}]
					},
					operationType: {
						rules: [{
							required: true,
							message: '请选择设施类型!'
						}]
					},
          workPlanDetailListStr:{
            rules: [{
              required: true,
              message: '请选择计划项目!'
            }]
          },
					userId: {
						rules: [{
							required: true,
							message: '请选择参与人!'
						}]
					},
					planType: {
						rules: [{
							required: true,
							message: '请选择日程类型!'
						}]
					},
				},
				rules: {
					title: {
						required: true,
						message: '请输入标题!'
					},
					operationType: {
						required: true,
						message: '请选择设施类型!'
					},
          workPlanDetailListStr: {
            required: true,
            message: '请选择计划项目!'
          },
					rangeTime: {
						required: true,
						message: '请选择日程时间!'
					},
					userId: {
						required: true,
						message: '请选择执行人!'
					},
					siteId: {
						required: true,
						message: '请选择设施!'
					}
				},
				url: {
					add: '/om/work/plan/add',
					edit: '/om/work/plan/edit',
					queryByIds: '/sys/user/queryByIds'
				},
				showType: 1, //1.添加，2.编辑
				formList: [],
				setObj: {},
				index: 0
			}
		},
		created() {
      if(window.localStorage.getItem('projectCode')){
        this.projectCode = window.localStorage.getItem('projectCode')
      }
      this.initPlanTypes()
    },
		methods: {
      initPlanTypes() {
        getWorkPlanTypes().then(res => {
          if (res && res.success && Array.isArray(res.result) && res.result.length > 0) {
            this.planTypeOptions = res.result
            this.createPlanTypeOptions = res.result.filter(item => item.value !== '10')
          } else {
            this.fallbackPlanTypes()
          }
        }).catch(() => {
          this.fallbackPlanTypes()
        })
      },
      fallbackPlanTypes() {
        this.planTypeOptions = [
          { value: '1', title: '人工创建' },
          { value: '10', title: '周期计划' }
        ]
        this.createPlanTypeOptions = [
          { value: '1', title: '人工创建' }
        ]
      },
      async handleCompleteCycleTask(record) {
        let taskId = this.model.maintenanceTaskId
        if (!taskId && this.model.options) {
          try {
            const opts = typeof this.model.options === 'string' ? JSON.parse(this.model.options) : this.model.options
            taskId = opts && opts.maintenanceTaskId
          } catch (e) {
            console.error(e)
          }
        }
        if (!taskId) {
          this.$message.warning('未获取到关联的周期运维任务信息')
          return
        }
        this.cycleTaskLoading = true
        try {
          const res = await getAction(`/om/maintenance/tasks/${taskId}?terminal=WEB`)
          if (res && res.success && res.result) {
            const task = res.result
            if (task.action) {
              if (!task.action.params) task.action.params = {}
              if (!task.action.params.siteId && (task.siteId || this.model.siteId)) {
                task.action.params.siteId = task.siteId || this.model.siteId
              }
              if (!task.action.params.siteName && (task.siteName || this.model.siteName)) {
                task.action.params.siteName = task.siteName || this.model.siteName
              }
              const opened = await openMaintenanceAction(task.action, task.businessType, this)
              if (opened) {
                this.close()
              }
            } else {
              this.$message.info('该周期任务暂无可执行的跳转动作')
            }
          } else {
            this.$message.error((res && res.message) || '获取运维任务详情失败')
          }
        } catch (err) {
          this.$message.error('网络请求异常，请稍后重试')
        } finally {
          this.cycleTaskLoading = false
        }
      },
      handleOpenComplete(record) {
        this.$refs.completeModal.complete(record, this.model.title)
      },
      handleViewProof(record) {
        this.$refs.completeModal.view(record, this.model.title)
      },
      handleDetailCompleteOk() {
        if (this.model && this.model.id) {
          getAction('/om/work/plan/' + this.model.id).then(res => {
            if (res && res.success && res.result) {
              this.model = res.result
              this.model.type = this.model.type != null ? String(this.model.type) : '1'
              if (!this.model.type_dictText) {
                this.model.type_dictText = this.model.type === '10' ? '周期计划' : '人工创建'
              }
              if (this.$refs.iwupload1) {
                this.$refs.iwupload1.loadUploadFiles('om_work_plan', this.model.id)
              }
            }
          })
        }
        this.$emit('ok')
      },
      canComplete() {
        if (!this.userInfo || !this.userInfo.id) return false
        const currentUserId = this.userInfo.id
        if (this.model && this.model.createBy == currentUserId) return true
        if (this.model && (this.model.userId == currentUserId || this.model.userId == String(currentUserId))) return true
        if (this.model && this.model.executorIds && Array.isArray(this.model.executorIds)) {
          if (this.model.executorIds.includes(currentUserId) || this.model.executorIds.includes(Number(currentUserId))) {
            return true
          }
        }
        if (this.executorIds && Array.isArray(this.executorIds)) {
          if (this.executorIds.includes(currentUserId) || this.executorIds.includes(Number(currentUserId))) {
            return true
          }
        }
        if (this.model && this.model.executorNames && this.userInfo.realname) {
          if (this.model.executorNames.split(',').includes(this.userInfo.realname)) {
            return true
          }
        }
        return false
      },
			moment,
			changeTypes(e, index, objString) {
				this.$set(this.formList[index], objString, e)
				if (this.$refs.ruleForm) {
					const forms = Array.isArray(this.$refs.ruleForm) ? this.$refs.ruleForm : [this.$refs.ruleForm]
					if (forms[index]) {
						forms[index].clearValidate(objString)
					}
				}
				this.$forceUpdate()
			},
      changeModelType(e){
        this.$set(this.model, 'workPlanDetailListStr', e)
      },
			operationTypeChange(value, index) {
				if (value == undefined) return
				if (this.showType == 1) {
					this.$set(this.formList[index], 'operationType', value)
					this.$set(this.formList[index], 'siteId', '')
					if (this.selectedSiteList && this.selectedSiteList[index]) {
						this.$set(this.selectedSiteList, index, [])
					}
					if (this.$refs.ruleForm) {
						const forms = Array.isArray(this.$refs.ruleForm) ? this.$refs.ruleForm : [this.$refs.ruleForm]
						if (forms[index]) {
							forms[index].clearValidate('operationType')
							forms[index].clearValidate('siteId')
						}
					}
					this.$forceUpdate()
				} else {
					this.model.operationType = value
					this.operationTypeItem = value
					this.selectedSite = ''
				}
			},
			deleteItem(index) {
				if (this.formList.length > 1) {
					this.formList.splice(index, 1)
					this.selectedSiteList.splice(index, 1)
					this.selectedUserList.splice(index, 1)
				}
			},
			copyItem(index) {
				let obj = Object.assign({}, this.formList[index])
				this.formList.splice(index + 1, 0, obj)
				let list = this.selectedSiteList[index].map(e => e)
				this.selectedSiteList.splice(index + 1, 0, list)
				let userList = (this.selectedUserList[index] || []).map(e => e)
				this.selectedUserList.splice(index + 1, 0, userList)
			},
			addItem(index) {
				let obj = Object.assign({}, this.setObjCopy)
				this.formList.splice(index + 1, 0, obj)
				this.selectedSiteList.splice(index + 1, 0, [])
				this.selectedUserList.splice(index + 1, 0, [])
			},
			add() {
				setTimeout(() => {
					console.log(this.$refs.ruleForm)
					this.$forceUpdate()
				}, 3000)
        this.tabsKey = '1'
        this.setObj = {
					title: '工作计划',
					type: '1',
					operationType: '',
					// urgentLevel: '',
					remark: '',
					status: '',
					siteId: '',
					rangeTime: '',
          workPlanDetailList: [],
          workPlanDetailListStr:'',
          executorIds: [],
          executorNames: '',
          userId: ''
				}
				this.setObjCopy = JSON.parse(JSON.stringify(this.setObj))
				this.formList = [this.setObj]
				this.selectedSiteList = [[]]
				this.selectedUserList = [[]]
				this.userIndex = 0
				this.showType = 1
				this.visible = true
				this.$nextTick(() => {
					// this.form.setFieldsValue(this.setObj)
          for(let i = 0;i<this.$refs.iwupload.length;i++){
            this.$refs.iwupload[i].loadUploadFiles()
          }
				})
				// this.edit({})
			},
			edit(record) {
        console.log('edit')
        this.tabsKey = '1'
				this.showType = 2
				this.form.resetFields()
				this.model = Object.assign({}, record)
				this.model.type = this.model.type != null ? String(this.model.type) : '1'
				if (!this.model.type_dictText) {
					this.model.type_dictText = this.model.type === '10' ? '周期计划' : '人工创建'
				}
				this.selectedSite = []
				this.siteIds = ''
				this.selectedUser = []
				this.executorIds = []
				this.userId = ''
				this.visible = true
        console.log('model',this.model)
        this.model.workPlanDetailListStr = []
        if (this.model.workPlanDetailList && Array.isArray(this.model.workPlanDetailList)) {
          this.model.workPlanDetailList.forEach(item=>{
            this.model.workPlanDetailListStr.push(item.title+'')
          })
        }
        if(this.model.id){
          this.startUser={
            key:this.model.createBy,
            label:this.model.createBy_userName
          }
        }
				this.$nextTick(() => {
					this.form.setFieldsValue(
						pick(
							this.model,
							'title',
							'operationType',
							// 'remindType',
							// 'reminders',
							// 'remind',
							// 'urgentLevel',
							'plancolor',
							'remark',
							'status',
              'siteId',
              'workPlanDetailListStr'
						)
					)
					this.getUser(this.model)
					// this.allDay = this.model.allDay && this.model.allDay == 1 ? true : false
					this.form.setFieldsValue({
						rangeTime: [
							this.model.startTime ? moment(this.model.startTime) : null,
							this.model.endTime ? moment(this.model.endTime) : null
						]
					})
					this.siteIds = this.model.siteId ? this.model.siteId : null
					if (this.model.siteName) {
						this.selectedSite.push(this.model.siteName)
					}
          
          setTimeout(()=>{
            if (this.$refs.SiteListModal && this.$refs.PipeListModal) {
              if (this.model.operationType == 1) {
              	this.$refs.SiteListModal.edit(this.selectedSite, this.siteIds)
              } else {
              	this.$refs.PipeListModal.edit(this.selectedSite, this.siteIds)
              }
            }
          })


					// this.form.setFieldsValue({ startTime: this.model.startTime ? moment(this.model.startTime) : null })
					// this.form.setFieldsValue({ endTime: this.model.endTime ? moment(this.model.endTime) : null })
					// this.form.setFieldsValue({ createTime: this.model.createTime ? moment(this.model.createTime) : null })
					//this.form.setFieldsValue({ updateTime: this.model.updateTime ? moment(this.model.updateTime) : null })
				})
			},
			getUser(record) {
				this.userId = record.userId || ''
				let idsStr = ''
				if (record.executorNames) {
					this.selectedUser = record.executorNames.split(',').filter(Boolean)
				}
				if (record.executorIds && record.executorIds.length > 0) {
					this.executorIds = [...record.executorIds]
					idsStr = this.executorIds.join(',')
				} else if (this.userId) {
					idsStr = this.userId
				}
				if (!idsStr) {
					return
				}
				getAction(this.url.queryByIds, {
					userIds: idsStr
				}).then((res) => {
					if (res.success && res.result && res.result.length > 0) {
						this.selectedUser = []
						this.executorIds = []
						for (var i = 0; i < res.result.length; i++) {
							this.selectedUser.push(res.result[i].realname)
							this.executorIds.push(res.result[i].id)
						}
						if (this.$refs.UserListModal) {
							this.$refs.UserListModal.edit(res.result, idsStr)
						}
					}
				})
			},
			selectUserIds() {
				if (this.disableSubmit) return
				const idStr = this.executorIds && this.executorIds.length ? this.executorIds.join(',') : (this.userId || '')
				this.$refs.UserListModal.add(this.selectedUser, idStr)
			},
			selectUserIdsForBatch(index) {
				this.userIndex = index
				const currentItem = this.formList[index] || {}
				const idStr = currentItem.executorIds && currentItem.executorIds.length ? currentItem.executorIds.join(',') : (currentItem.userId || '')
				const names = this.selectedUserList[index] || []
				this.$refs.UserListModal.add(names, idStr)
			},
			// 子modal回调
			choseUser: function(userList) {
				let names = []
				let ids = []
				let idStr = ''
				for (var i = 0; i < userList.length; i++) {
					names.push(userList[i].realname)
					ids.push(userList[i].id)
					idStr += userList[i].id + ','
				}
				if (this.showType == 1) {
					this.$set(this.selectedUserList, this.userIndex, names)
					this.$set(this.formList[this.userIndex], 'executorIds', ids)
					this.$set(this.formList[this.userIndex], 'executorNames', names.join(','))
					this.$set(this.formList[this.userIndex], 'userId', idStr)
					if (this.$refs.ruleForm && this.$refs.ruleForm[this.userIndex]) {
						this.$refs.ruleForm[this.userIndex].clearValidate('userId')
					}
					this.$forceUpdate()
				} else {
					this.selectedUser = names
					this.executorIds = ids
					this.userId = idStr
					this.$set(this.model, 'executorIds', this.executorIds)
					this.$set(this.model, 'executorNames', this.selectedUser.join(','))
					this.$set(this.model, 'userId', this.userId)
				}
			},
			close() {
				this.$emit('close')
				this.visible = false
				this.disableSubmit = false
				this.selectedUser = []
				this.executorIds = []
			},
			// 子modal回调
			choseSite: function(siteList) {
				this.selectedSite = []
				this.siteIds = ''
				for (var i = 0; i < siteList.length; i++) {
					this.selectedSite.push(siteList[i].name)
					this.siteIds = siteList[i].id
					if (this.showType == 1) {
						this.$set(this.selectedSiteList, this.index, [siteList[i].name])
						this.$set(this.formList[this.index], 'siteId', siteList[i].id)
						if (this.$refs.ruleForm) {
							const forms = Array.isArray(this.$refs.ruleForm) ? this.$refs.ruleForm : [this.$refs.ruleForm]
							if (forms[this.index]) {
								forms[this.index].clearValidate('siteId')
							}
						}
						this.$forceUpdate()
					}
				}
			},
			// 子modal回调
			choseSiteByPipe: function(siteList) {
				this.selectedSite = []
				this.siteIds = ''
				for (var i = 0; i < siteList.length; i++) {
					this.selectedSite.push(siteList[i].title)
					this.siteIds = siteList[i].id
					if (this.showType == 1) {
						this.$set(this.selectedSiteList, this.index, [siteList[i].title])
						this.$set(this.formList[this.index], 'siteId', siteList[i].id)
						if (this.$refs.ruleForm) {
							const forms = Array.isArray(this.$refs.ruleForm) ? this.$refs.ruleForm : [this.$refs.ruleForm]
							if (forms[this.index]) {
								forms[this.index].clearValidate('siteId')
							}
						}
						this.$forceUpdate()
					}
				}
			},

			selectSite(operationType, index) {
				console.log(operationType, index)
				if (index >= 0) {
					this.index = index
					// this.selectedSiteList[this.index] = new Array()
				}
				// if(operationType==2){
				// this.$refs.PipeListModal.add(this.selectedSite, this.siteIds)
				// }else{
				this.$refs.SiteListModal.add(this.selectedSite, this.siteIds)
				// }
			},

			selectPipe(index) {
				if (index >= 0) {
					this.index = index
					// this.selectedSiteList[this.index] = new Array()
				}
				this.$refs.PipeListModal.add(this.selectedSite, this.siteIds)
			},
			handleSubmit() {
				const forms = this.$refs.ruleForm
					? (Array.isArray(this.$refs.ruleForm) ? this.$refs.ruleForm : [this.$refs.ruleForm])
					: []
				if (!forms.length) {
					return
				}
				const validatePromises = forms.map(form => {
					return new Promise(resolve => {
						form.validate(valid => {
							resolve(Boolean(valid))
						})
					})
				})
				Promise.all(validatePromises).then(results => {
					const isAllValid = results.every(Boolean)
					if (!isAllValid) {
						this.$message.warning('请检查并完善表单必填信息！')
						return
					}

					this.confirmLoading = true
					const planList = this.formList.map((item, index) => {
						let copy = Object.assign({}, item)
						if (Array.isArray(copy.type)) {
							copy.type = copy.type.join(',')
						}
						if (copy.rangeTime && Array.isArray(copy.rangeTime) && copy.rangeTime.length === 2) {
							copy.startTime = moment(copy.rangeTime[0]).format('YYYY-MM-DD HH:mm:ss')
							copy.endTime = moment(copy.rangeTime[1]).format('YYYY-MM-DD HH:mm:ss')
						}
						delete copy.rangeTime

						if (copy.workPlanDetailListStr) {
							let detailArr = typeof copy.workPlanDetailListStr === 'string'
								? copy.workPlanDetailListStr.split(',').filter(Boolean)
								: copy.workPlanDetailListStr
							copy.workPlanDetailList = (detailArr || []).map(titleItem => ({ title: titleItem }))
						}
						delete copy.workPlanDetailListStr

						if ((!copy.executorIds || !copy.executorIds.length) && copy.userId) {
							copy.executorIds = copy.userId.split(',').filter(Boolean).map(Number)
						}
						if (!copy.executorNames && this.selectedUserList[index] && this.selectedUserList[index].length) {
							copy.executorNames = this.selectedUserList[index].join(',')
						}

						if (this.$refs.iwupload) {
							const uploader = Array.isArray(this.$refs.iwupload) ? this.$refs.iwupload[index] : this.$refs.iwupload
							if (uploader && typeof uploader.getUploadListToFromData === 'function') {
								copy = uploader.getUploadListToFromData(copy)
							}
						}
						return copy
					})

					workPlanAddBatch({
						planList: planList
					}).then(data => {
						if (data && data.success) {
							this.$message.success(data.message || '新增成功')
							this.$emit('ok')
							this.close()
						} else {
							this.$message.warning((data && data.message) || '新增失败')
						}
					}).catch(err => {
						this.$message.error((err && err.message) || '网络异常，提交失败')
					}).finally(() => {
						this.confirmLoading = false
					})
				})
			},
			handleOk(s) {
				const that = this
        console.log(this.formList)
        console.log(this.showType)
				if (this.showType == 1) {
					this.handleSubmit()
					return
				}
				// 触发表单验证
				this.form.validateFields((err, values) => {
					if (!err) {
						that.confirmLoading = true
						let formData = Object.assign(this.model, values)
						//时间格式化

						// formData.startTime = formData.startTime ? formData.startTime.format('YYYY-MM-DD HH:mm:ss') : null
						// formData.endTime = formData.endTime ? formData.endTime.format('YYYY-MM-DD HH:mm:ss') : null
						let rangeTimeValue = values['rangeTime']
						let res = {
							rangeTime: [
								rangeTimeValue[0].format('YYYY-MM-DD HH:mm:ss'),
								rangeTimeValue[1].format('YYYY-MM-DD HH:mm:ss')
							]
						}
						formData.startTime = res.rangeTime[0]
						formData.endTime = res.rangeTime[1]
						formData.siteId = that.siteIds == null || that.siteIds == '' ? null : that.siteIds
						formData.userId = that.userId
						formData.executorIds = that.executorIds && that.executorIds.length ? that.executorIds : []
						formData.executorNames = that.selectedUser && that.selectedUser.length ? that.selectedUser.join(',') : ''

            if(this.disableSubmit){
              delete formData.workPlanDetailListStr
            }else{
              formData.workPlanDetailList = []
              if(formData.workPlanDetailListStr){
                if(typeof formData.workPlanDetailListStr=='string')formData.workPlanDetailListStr = formData.workPlanDetailListStr.split(',')
                formData.workPlanDetailListStr.forEach(item=>{
                  formData.workPlanDetailList.push({
                    title:item
                  })
                })
                delete formData.workPlanDetailListStr
              }
            }


            formData = this.$refs.iwupload1.getUploadListToFromData(formData)
						// formData.reminderTime = this.handleReminders(formData.reminders, formData.startTime)
						// formData.allDay = formData.allDay ? formData.allDay : 2
						let httpurl = ''
						let method = ''
						if (!this.model.id) {
							httpurl += this.url.add
							method = 'post'
							formData.status = 1
						} else {
							httpurl += this.url.edit
							method = 'put'
						}
						if (s) {
							formData.status = 2
							formData.completeTime = moment().format('YYYY-MM-DD HH:mm:ss')
						}
            console.log('formData',formData)
						httpAction(httpurl, formData, method)
							.then((res) => {
								if (res.success) {
									that.$message.success(res.message)
									that.$emit('ok')
									that.close()
								} else {
									that.$message.warning(res.message)
								}
							})
							.finally(() => {
								that.confirmLoading = false
							})
					}
				})
			},
			handleCancel() {
        this.$emit('ok')
				this.close()
			},
			handleReminders(str, time) {
				let remindTime = time
				if (str == 3) {
					remindTime = moment(time).subtract(5, 'minute').format('YYYY-MM-DD HH:mm:ss')
				} else if (str == 4) {
					remindTime = moment(time).subtract(10, 'minute').format('YYYY-MM-DD HH:mm:ss')
				} else if (str == 5) {
					remindTime = moment(time).subtract(15, 'minute').format('YYYY-MM-DD HH:mm:ss')
				} else if (str == 6) {
					remindTime = moment(time).subtract(30, 'minute').format('YYYY-MM-DD HH:mm:ss')
				} else if (str == 7) {
					remindTime = moment(time).subtract(1, 'hour').format('YYYY-MM-DD HH:mm:ss')
				} else if (str == 8) {
					remindTime = moment(time).subtract(2, 'hour').format('YYYY-MM-DD HH:mm:ss')
				}
				// console.log(time, remindTime, str)
				return remindTime
			}
		}
	}
</script>

<style lang="less" scoped>
	.ruleForm {
		/deep/ .el-form-item__label {
			color: #fff;
		}
	}



</style>
